import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface OptionProps {
  active: boolean;
}

interface OptionDetailProps {
  highlight: boolean;
}

export const Container = styled.div`
  display: flex;

  margin: 24px 0 8px 0;
  padding: 0 16px;
  min-height: fit-content;

  @media ${({ theme }) => theme.device.desktop} {
    padding: 0;
    margin-top: 0;
  }
`;

export const OptionTitle = styled.span<OptionProps>`
  color: ${({ active }) => (active ? ColorPalette.HEX.CharlestonGreen : ColorPalette.HEX.DimGray)};
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
`;

export const OptionDetail = styled.span<OptionDetailProps>`
  color: ${({ highlight, theme }) => (highlight ? theme.primaryBackgroundColor : ColorPalette.HEX.DimGray)};
  font-size: 12px;
  line-height: 18px;
`;

export const Option = styled.button<OptionProps>`
  background: ${({ active }) => (active ? ColorPalette.HEX.White : ColorPalette.HEX.BrightGray8)};
  flex: 1;
  padding-bottom: 16px;
  margin: 0 1px;
  border: ${({ active }) => (active ? 'none' : `1px solid ${ColorPalette.HEX.BrightGray8}`)};
  border-bottom: ${({ active, theme }) => (active ? `4px solid ${theme.primaryBackgroundColor}` : 'none')};
  padding: 12px 0;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  box-shadow: ${({ active }) => (active ? '0 2px 20px 0 rgb(228 221 219 / 50%)' : 'none')};
`;

export const Divider = styled.div`
  background: ${ColorPalette.HEX.LavenderGray};
  width: 1px;
  height: 60px;
  margin: 0 8px;
`;
